/**
 * A Google tag no HTML é a responsável pelos page_views.
 * A medição otimizada do GA4 pode acompanhar as mudanças de histórico da SPA.
 * Não envia page_view manual, evitando duplicação com essa medição automática.
 */
export default function AnalyticsTracker() {
  return null;
}
